import Competencies from "./maintenance/Competencies";
import CompetenciesType from "./maintenance/CompetenciesType";
import KnowledgeAreas from "./maintenance/KnowledgeAreas";
import Maintenance from "./maintenance/Maintenance";
import Area from "./maintenance/Area";
import MeasurementUnit from "./maintenance/MeasurementUnit";
import PoliticsAndProcedures from "./maintenance/PoliticsAndProcedures";
import CompetenciesDesc from "./maintenance/CompetenciesDesc";
import Purpose from "./maintenance/Purpose";
import EducationLevel from "./maintenance/EducationLevel";
import Titles from "./maintenance/Titles";
import Courses from "./maintenance/Courses";
import TechnicalKnowledge from "./maintenance/TechnicalKnowledge";
import DescriptorSelection from "./descriptor/DescriptorSelection";
// import JobDescription from "./descriptor/JobDescription";
import UserMenu from "./UserMenu";
import MenuDesc from "./descriptor/MenuDesc";
import MantIndicator from "./maintenance/MantIndicator";
import GeneralData from "./descriptor/GeneralData";
import MoCompetencies from "./descriptor/MoCompetencies";
import AssignCompetencies from "./descriptor/AssignCompetencies";
import CompetenciesLevel from "./descriptor/CompetenciesLevel";
import TotalCompetence from "./maintenance/TotalCompetence";
import DashBoardPuestos from "./descriptor/DashBoardPuestos";
import DocumentoDescriptorPDF from "./DocumentoPDF/DocumentoDescriptorPDF";
const DescriptorProfilesRouter = [
  {
    type: "private",
    path: "/descriptores-perfiles/competencias-del-descriptor",
    roles: [
      "administrador",
      "Responsable_Descriptores_Perfiles",
      "alta_direccion",
      "alta_direccion",
    ],
    component: Competencies,
    exact: true,
  },
  {
    type: "private",
    path: "/descriptores-perfiles/areas",
    roles: [
      "administrador",
      "Responsable_Descriptores_Perfiles",
      "alta_direccion",
    ],
    component: Area,
    exact: true,
  },
  {
    type: "private",
    path: "/descriptores-perfiles/compentencias",
    roles: [
      "administrador",
      "Responsable_Descriptores_Perfiles",
      "alta_direccion",
    ],
    component: CompetenciesDesc,
    exact: true,
  },
  {
    type: "private",
    path: "/descriptores-perfiles/tipo-de-competencia",
    roles: [
      "administrador",
      "Responsable_Descriptores_Perfiles",
      "alta_direccion",
    ],
    component: CompetenciesType,
    exact: true,
  },
  {
    type: "private",
    path: "/descriptores-perfiles/total-de-competencias",
    roles: [
      "administrador",
      "Responsable_Descriptores_Perfiles",
      "alta_direccion",
    ],
    component: TotalCompetence,
    exact: true,
  },
  {
    type: "private",
    path: "/descriptores-perfiles/unidad-de-medida",
    roles: [
      "administrador",
      "Responsable_Descriptores_Perfiles",
      "alta_direccion",
    ],
    component: MeasurementUnit,
    exact: true,
  },
  {
    type: "private",
    path: "/descriptores-perfiles/políticas-y-procedimientos",
    roles: [
      "administrador",
      "Responsable_Descriptores_Perfiles",
      "alta_direccion",
    ],
    component: PoliticsAndProcedures,
    exact: true,
  },
  {
    type: "private",
    path: "/descriptores-perfiles/mantenimientos",
    roles: [
      "administrador",
      "Responsable_Descriptores_Perfiles",
      "alta_direccion",
    ],
    component: Maintenance,
    exact: true,
  },
  {
    type: "private",
    path: "/descriptores-perfiles/propositos",
    roles: [
      "administrador",
      "Responsable_Descriptores_Perfiles",
      "alta_direccion",
    ],
    component: Purpose,
    exact: true,
  },
  {
    type: "private",
    path: "/descriptores-perfiles/titulos",
    roles: [
      "administrador",
      "Responsable_Descriptores_Perfiles",
      "alta_direccion",
    ],
    component: Titles,
    exact: true,
  },
  {
    type: "private",
    path: "/descriptores-perfiles/áreas-de-conocimiento",
    roles: [
      "administrador",
      "Responsable_Descriptores_Perfiles",
      "alta_direccion",
    ],
    component: KnowledgeAreas,
    exact: true,
  },
  {
    type: "private",
    path: "/descriptores-perfiles/nivel-de-educacion",
    roles: [
      "administrador",
      "Responsable_Descriptores_Perfiles",
      "alta_direccion",
    ],
    component: EducationLevel,
    exact: true,
  },
  {
    type: "private",
    path: "/descriptores-perfiles/cursos",
    roles: [
      "administrador",
      "Responsable_Descriptores_Perfiles",
      "alta_direccion",
    ],
    component: Courses,
    exact: true,
  },
  {
    type: "private",
    path: "/descriptores-perfiles/conocimiento-técnico",
    roles: [
      "administrador",
      "Responsable_Descriptores_Perfiles",
      "alta_direccion",
    ],
    component: TechnicalKnowledge,
    exact: true,
  },
  {
    type: "private",
    path: "/descriptores-perfiles/seleccion-del-descriptor/:id/:nombreFuncion",
    roles: [
      "administrador",
      "jefe",
      "Responsable_Descriptores_Perfiles",
      "empleado",
      "alta_direccion",
    ],
    component: DescriptorSelection,
    exact: true,
  },
  {
    type: "private",
    path: "/descriptores-perfiles/menu-usuario",
    roles: [
      "administrador",
      "jefe",
      "Responsable_Descriptores_Perfiles",
      "empleado",
      "alta_direccion",
    ],
    component: UserMenu,
    exact: true,
  },
  {
    type: "private",
    path: "/descriptores-perfiles/descriptor/:id/:nombre/:idFunc/:nombreFuncion",
    roles: [
      "administrador",
      "jefe",
      "Responsable_Descriptores_Perfiles",
      "empleado",
      "alta_direccion",
    ],
    component: MenuDesc,
    exact: false,
  },
  {
    type: "private",
    path: "/descriptor-perfil/:miDescriptor/:id/:nombre/:idFunc/:nombreFuncion",
    roles: [
      "administrador",
      "jefe",
      "Responsable_Descriptores_Perfiles",
      "empleado",
      "alta_direccion",
    ],
    component: MenuDesc,
    exact: false,
  },
  {
    type: "private",
    path: "/descriptores-perfiles/indicadores",
    roles: [
      "administrador",
      "Responsable_Descriptores_Perfiles",
      "alta_direccion",
    ],
    component: MantIndicator,
    exact: false,
  },
  {
    type: "private",
    path: "/descriptores-perfiles/descriptor/:id/:nombre_descriptor/:idFunc/:nombre_funcion",
    roles: [
      "administrador",
      "jefe",
      "Responsable_Descriptores_Perfiles",
      "empleado",
      "alta_direccion",
    ],
    component: GeneralData,
    exact: false,
  },
  {
    type: "private",
    path: "/descriptores-perfiles/descriptor/:id/nivel-competencias",
    roles: [
      "administrador",
      "jefe",
      "Responsable_Descriptores_Perfiles",
      "empleado",
      "alta_direccion",
    ],
    component: CompetenciesLevel,
    exact: false,
  },
  {
    type: "private",
    path: "/descriptores-perfiles/descriptor/:id/asignar-competencias",
    roles: [
      "administrador",
      "jefe",
      "Responsable_Descriptores_Perfiles",
      "empleado",
      "alta_direccion",
    ],
    component: AssignCompetencies,
    exact: false,
  },
  {
    type: "private",
    path: "/descriptores-perfiles/manuales-competencias",
    roles: [
      "administrador",
      "jefe",
      "Responsable_Descriptores_Perfiles",
      "empleado",
      "alta_direccion",
    ],
    component: MoCompetencies,
    exact: true,
  },
  {
    type: "private",
    // path: "/descriptores-perfiles/dashboard-descriptor-puesto",
    path: "/descriptores-perfiles/tablero-descriptores-de-puesto",
    roles: ["administrador", "Responsable_Descriptores_Perfiles"],
    component: DashBoardPuestos,
    exact: true,
  },
  {
    // type: "private",
    path: "/descriptores-perfiles/descargar-descriptor/:id/:nombre",
    // roles: ["administrador", "Responsable_Descriptores_Perfiles"],
    component: DocumentoDescriptorPDF,
    exact: true,
  },
];

export default DescriptorProfilesRouter;
